import { useParams, Navigate, useNavigate } from 'react-router-dom';
import Result from '../../components/query/Result';
import { StorageService } from '../../services/storage';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { getConversation } from '../../services/conversation';
import { STORAGE_KEYS } from '../../constants/storageKeys';

const QueryResultPage = ({ print = false }) => {
	const { id } = useParams();
	const { t } = useTranslation();
	const [conversation, setConversation] = useState(null);
	const [followUpContent, setFollowUpContent] = useState(null);
	const navigate = useNavigate();

	const token = StorageService.getItem(STORAGE_KEYS.AUTH_TOKEN);
	if (!token) {
		return <Navigate to='/' replace />;
	}

	const fetchConversation = async () => {
		const data = await getConversation(token, id);
		if (data.hasOwnProperty('conversation') && data.conversation != null) {
			setConversation(data.conversation);
			document.title = `${t('general.app_name')} | ${data.conversation.messages[0].question}`;
		} else {
			navigate('/');
		}
	};

	useEffect(() => {
		setFollowUpContent(null);
		fetchConversation();
	}, [id, setFollowUpContent]);

	useEffect(() => {
		if (conversation && conversation.messages.length > 1 && conversation.messages[1]) {
			setFollowUpContent(conversation.messages[1]);
		}
	}, [conversation]);

	if (!conversation) {
		return;
	}

	const handleFollowCompleteAction = (data) => {
		setFollowUpContent(data);
	};

	return (
		<div className='flex flex-row justify-center items-center h-[calc(100vh)] px-8'>
			<div className='w-full max-w-2xl h-[calc(100vh)]'>
				<Result
					title={conversation?.messages[0]?.question}
					content={conversation?.messages[0]?.answer}
					references={conversation?.messages[0]?.sources}
					elasticDocuments={conversation?.messages[0]?.elasticDocuments}
					conversationId={conversation?.messages[0]?.conversationId}
					followUpContent={followUpContent}
					followUpEnabled={conversation?.followUpEnabled}
					onFollowCompleteAction={handleFollowCompleteAction}
					id={id}
					print={print}
					aiModelReference={conversation?.aiModelReference}
				/>
			</div>
		</div>
	);
};

export default QueryResultPage;
